import React from "react";
import {Row, Col, BackTop,} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, zoologyModel } from "@reco-w/zoology-models";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs, Scrollbar } from "swiper";
import { R2040ArticleList } from "src/apps/common/r2040.article.list";
import { Consulting } from "src/apps/consulting/consulting";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs, Scrollbar]);

export namespace Zoology {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, zoologyModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.zoology;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/zoology`);
        }
        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 60, resourceSlides: 3, resourceSpace: 60, collaborateIndex: 1 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, resourceSlides: 1, resourceSpace: 0 });
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, resourceSlides: 3, resourceSpace: 60 });
            }
        }

        renderResource() {
            const { state } = this.props,
                resourceSlides = state!.resourceSlides,
                resourceSpace = state!.resourceSpace;
            const zyData = [
                "assets/images/second/dc-logo1.jpg",
                // "assets/images/second/dc-logo2.jpg",
                "assets/images/second/dc-logo3.jpg",
                // "assets/images/second/dc-logo4.jpg",
                // "assets/images/second/dc-logo5.jpg",
                "assets/images/second/dc-logo6.jpg",
                // "assets/images/second/dc-logo7.jpg"
            ]
            return (
                <div className="block-content resource-content">
                    <div className="container">
                        <div className="second-title">
                            <span>大厂资源</span>
                        </div>
                    </div>
                    <div className="resource-box">
                        {/*<div className="swiper-button-prev" />*/}
                        {/*<div className="swiper-button-next" />*/}
                        <div className="container">
                            <Swiper
                                slidesPerView={resourceSlides}
                                className="resource-swiper"
                                style={{ height: 350 }}
                                scrollbar={{
                                    hide: false
                                }}
                                navigation={{
                                    nextEl: '.resource-box .swiper-button-next',
                                    prevEl: '.resource-box .swiper-button-prev'
                                }}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                                }}
                                spaceBetween={resourceSpace}
                            >
                                {zyData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="resource-img">
                                                <ImageAuto.Component src={item} width="100%" height="100%" radius={0} />
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </div>
                </div>
            )
        }


        renderQuestion() {
            return (
                <div className="block-content ecocline-content">
                    <div className="container">
                        <div className="second-title">
                            <span>生态优势</span>
                        </div>
                        <Row className="question-grid" gutter={30}>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/st-bg1.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/st-icon1.png" /></div>
                                        <div className="size-22">大企业</div>
                                        <div className="size-18 mt20">领先技术对接</div>
                                        <div className="mt60"><img src='assets/images/second/primary-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/st-bg2.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/st-icon2.png" /></div>
                                        <div className="size-22">大企业</div>
                                        <div className="size-18 mt20">生态体系进入</div>
                                        <div className="mt60"><img src='assets/images/second/primary-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/st-bg3.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/st-icon3.png" /></div>
                                        <div className="size-22">大企业</div>
                                        <div className="size-18 mt20">市场和商机对接</div>
                                        <div className="mt60"><img src='assets/images/second/primary-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }

        changeCollaborate(e) {
            this.dispatch("input", { collaborateIndex: e });
        }

        renderCollaborate() {
            const { state } = this.props,
                collaborateIndex = state!.collaborateIndex;
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>大厂合作</span>
                        </div>
                        <Row>
                            <Col xs={24} sm={24} md={7}>
                                <div className="collaborate-tabs">
                                    <div className={collaborateIndex === 1 ? "collaborate-tabs-item active" : "collaborate-tabs-item"} onClick={() => this.changeCollaborate(1)}>
                                        <div className="collaborate-tabs-date">2015~</div>
                                        <div className="collaborate-tabs-desc">与阿里云合作，共落地<span>5</span>家基地</div>
                                        <div className="collaborate-tabs-tag">[松江] [张江] [临港] [天津] [遂昌]</div>
                                    </div>
                                    <div className={collaborateIndex === 2 ? "collaborate-tabs-item active" : "collaborate-tabs-item"} onClick={() => this.changeCollaborate(2)}>
                                        <div className="collaborate-tabs-date">2020~</div>
                                        <div className="collaborate-tabs-desc">与宝马合作，共落地<span>2</span>家基地</div>
                                        <div className="collaborate-tabs-tag">[上海金桥] [四川成都]</div>
                                    </div>
                                    <div className={collaborateIndex === 3 ? "collaborate-tabs-item active" : "collaborate-tabs-item"} onClick={() => this.changeCollaborate(3)}>
                                        <div className="collaborate-tabs-date">2020~</div>
                                        <div className="collaborate-tabs-desc">与蚂蚁链合作，共落地<span>3</span>家基地</div>
                                        <div className="collaborate-tabs-tag">[杭州] [市北] [莲都]</div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={17}>
                                {
                                    collaborateIndex === 1 && <Row>
                                        <Col span={8}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-a1.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">阿里云创新中心上海松江基地</div>
                                            </div>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-a2.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">阿里云创新中心天津津南基地</div>
                                            </div>
                                        </Col>
                                        <Col span={8}>
                                            <div className="collaborate-write-item full">
                                                <ImageAuto.Component src="assets/images/second/hz-a3.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">阿里云创新中心上海张江基地<br />（张江纳贤路800号）</div>
                                            </div>
                                        </Col>
                                        <Col span={8}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-a4.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">阿里云创新中心上海临港基地</div>
                                            </div>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-a5.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">阿里云创新中心丽水遂昌基地</div>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                {
                                    collaborateIndex === 2 && <Row>
                                        <Col span={24}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-b1.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">宝马初创车库-阿里云创新中心（上海金桥）智能汽车产业创新基地</div>
                                            </div>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-b2.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">宝马初创车库-阿里云创新中心（成都高新）智能汽车产业创新基地</div>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                {
                                    collaborateIndex === 3 && <Row>
                                        <Col span={24}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-c1.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">杭州蚂蚁链产业创新中心</div>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-c2.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">丽水蚂蚁链产业创新中心</div>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="collaborate-write-item">
                                                <ImageAuto.Component src="assets/images/second/hz-c3.jpg" width="100%" height="100%" />
                                                <div className="collaborate-write-word">市北高新蚂蚁链产业创新中心</div>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }


        renderNews() {
            // const { state } = this.props,
            //     newsSlides = state!.newsSlides,
            //     newsSpace = state!.newsSpace;
            // const newsData = [
            //     {
            //         imgUrl: "assets/images/home/news-img1.png",
            //         title: "阿里云创新中心-宝马初创车库联合加速营甄选日l临近",
            //         desc: "8月4日，加速营甄选日即将在上海金桥"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img2.png",
            //         title: "[R·CEO CLUB 第三期] 科技型小企业专场闭门路演对接会成功举办",
            //         desc: "7月15日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img3.png",
            //         title: "虚实共生元宇宙 | R·CEO CLUB区块链专场沙龙成功举办",
            //         desc: "7月8日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img1.png",
            //         title: "阿里云创新中心-宝马初创车库联合加速营甄选日l临近",
            //         desc: "8月4日，加速营甄选日即将在上海金桥"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img2.png",
            //         title: "[R·CEO CLUB 第三期] 科技型小企业专场闭门路演对接会成功举办",
            //         desc: "7月15日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img3.png",
            //         title: "虚实共生元宇宙 | R·CEO CLUB区块链专场沙龙成功举办",
            //         desc: "7月8日，由瑞谷云企&瑞谷科创RECO"
            //     }
            // ]
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>最新动态</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            tagIds: ["887893341584146432"]
                        } as any)}
                        {/* <div className="news-swiper-box">
                            <Swiper
                                slidesPerView={newsSlides}
                                className="news-swiper mt10"
                                style={{ height: 460 }}
                                pagination={true}
                                spaceBetween={newsSpace}
                                // autoplay={{
                                //     delay: 3000,
                                //     disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                                // }}
                            >
                                {newsData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="news-swiper-item">
                                                <div className="news-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                </div>
                                                <div className="pg20">
                                                    <Paragraph ellipsis={{rows: 2, expandable: false}} className="mb0 size-18 gray-one-color">
                                                        {item.title}
                                                    </Paragraph>
                                                    <Paragraph ellipsis className="mb0 size-14 gray-three-color mt12">
                                                        {item.desc}
                                                    </Paragraph>
                                                    <div className="mt20">
                                                        <span className="list-arrow" />
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            )
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwdcst"></Consulting.Page>
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/dcst-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1"><img src="assets/images/banner/dc-text.png" /></div>
                                <div className="banner-text-name2 mt25">
                                    <div>帮助成长企业进入大企业生态体系</div>
                                    <div className="mt15">不止招引优质企业，更是优质企业的培育者和服务者</div>
                                </div>
                            </div>}
                        />
                        {this.renderResource()}
                        {this.renderQuestion()}
                        {this.renderCollaborate()}
                        {this.renderNews()}
                        {this.renderConsult()}
                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.zoology]);
}
